import {
  ReportC02ConsumptionEditFormValues,
  ReportEditFormValues,
  ReportSearchFormValues,
} from "./types";

/*-------------------------------------------------------------------------------------------
  REPORT 
---------------------------------------------------------------------------------------------*/
export const initialReportSearchForm: ReportSearchFormValues = {
  search: "",
};

export const initialReportEditForm: ReportEditFormValues = {
  name: null,
};

/*-------------------------------------------------------------------------------------------
  REPORT WAREHOUSE INVENTORY
---------------------------------------------------------------------------------------------*/
export const initialReportC02ConsumptionEditForm: ReportC02ConsumptionEditFormValues =
  {
    vehicleManufacturerId: null,
    vehicleModelId: null,
  };
